import BackoffOnFailure from './BackoffOnFailure';
export default (() => {
  let strategy;
  return sendHeartbeat => strategy || (strategy = new BackoffOnFailure(sendHeartbeat));
})();